import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef, Inject,
  NgZone,
  OnInit,
  Renderer2,
} from '@angular/core';

import {log} from "../../functions";
import {InterfaceService} from "../../services/interface.service";
import {ActivatedRoute, Route, Router} from "@angular/router";
import {WebrtcService} from "../../services/webrtc.service";
import {AllService} from "../../services/all.service";
import {NotifierWrapService} from "../../services/notifier-wrap.service";
import {CallService} from "../../services/call.service";

@Component({
  selector: 'app-page-calc',
  templateUrl: './page-calc.component.html',
  styleUrls: ['./page-calc.component.scss']
})
export class PageCalcComponent implements OnInit, AfterViewInit {
  roomCreated = false;
  constructor(
    public callService: CallService,
    public allService: AllService,
    public renderer: Renderer2,
    public interfaceService: InterfaceService,
    public cd: ChangeDetectorRef,
    public webrtcService: WebrtcService,
    private route: ActivatedRoute,
    public router: Router
  ) {
  }

  ngOnInit(): void {
    // this.cd.detach();
    // this.cd.detectChanges();
    this.route.params.subscribe((params) => {
      if (params.id) {
        this.webrtcService.roomId = params.id;
        this.callService.startCall$.next('video');
      } else {
        this.callService.endCall$.next();
      }
    });
    this.callService.endCall$.subscribe(() => {
      // this.renderer.removeClass(document.body, 'full');
    })
  }

  ngAfterViewInit() {
    this.renderer.addClass(document.body, 'full');

  }
  createNewRoom() {
    const rand = Math.random().toString(36).substring(2, 12);
    log('createNewRoom', rand)
    this.webrtcService.roomId = rand.toUpperCase();
    this.roomCreated = true;
    this.allService.copyTextToClipboard(location.protocol + '//' + location.host + this.urlRoom);
    this.cd.detectChanges();
    // this.router.navigate([`/call/${rand}`]);
  }
  get urlRoom(): string {
    return '/call/' + this.webrtcService.roomId;
  }
  startCall(type: 'video' | 'share' | 'audio' = 'video') {
    // this.endCall();
    this.router.navigateByUrl(this.urlRoom);
    this.callService.startCall$.next(type);
  }
}
